import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/client.service';



export const listClient = createAsyncThunk(
    "Client/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewClient = createAsyncThunk(
    "Client/adm-view",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.view(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createClient = createAsyncThunk(
    "Client/adm-create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.create(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateClient = createAsyncThunk(
    "Client/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.update(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteClient = createAsyncThunk(
    "Client/adm-delete",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.remove(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const uploadClientPassport = createAsyncThunk(
    "Client/adm-uploadPassport",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.uploadPassport(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const getByFilter = createAsyncThunk(
    "Client/adm-filter",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getByFilter(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const getByFilterV2 = createAsyncThunk(
    "Client/adm-filter",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getByFilterV2(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const createGroupeClient = createAsyncThunk(
    "Client/adm-createGroupe",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createGroupe(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const getGroupeClientList = createAsyncThunk(
    "Client/adm-getGroupeList",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getGroupeList(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)






const initialState = {
    loading: false,
    error: '',
    sel_Client: null
}

const ClientSlice = createSlice({
    name: "Client",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = ClientSlice;
export const { clear } = ClientSlice.actions;
export default reducer;